import React from "react";

import styles from "./TemplatePayslip.module.css";
import PropTypes from "prop-types";
import { endOfMonth, format, startOfMonth } from "date-fns";
import ImageWithBasePath from "core/img/imagewithbasebath";

const NetcoHourlyPayslip = ({ payrollDetails, companyDetails }) => {
  const additionRows = payrollDetails?.additionsList?.length + 1;
  const deductionRows = payrollDetails?.deductionsList?.length || 0;
  console.log(payrollDetails);
  return (
    <div className={styles.payslip}>
      <div className={styles.header}>
        {/* <ImageWithBasePath src="assets/img/logo.png" alt="Logo" /> */}
        <img
          src={`data:image/png;base64,${companyDetails?.companyLogo}`}
          alt="Compnay Logo"
          style={{ width: "110px" }}
        />
        <div className={styles["header-text"]}>
          <h2 className="mb-2">{companyDetails?.companyName.toUpperCase()}</h2>
          <h6>
            Payslip for the period of from &nbsp;
            {format(new Date(payrollDetails?.fromDate), "dd-MM-yyyy")} to&nbsp;
            {format(new Date(payrollDetails?.toDate), "dd-MM-yyyy")}
          </h6>
        </div>
        <div className={styles["header-date"]}>
          <h6>Date : {format(new Date(), "dd-MM-yyyy hh:mm:ss a")}</h6>
        </div>
      </div>
      <table className={styles.details}>
        <tr>
          <td>Employee No</td>
          <td>:&nbsp;&nbsp;&nbsp;{payrollDetails?.uniqueID}</td>
          <td>Designation</td>
          <td>:&nbsp;&nbsp;&nbsp;{payrollDetails?.designationName}</td>
        </tr>
        <tr>
          <td>Name</td>
          <td>:&nbsp;&nbsp;&nbsp;{payrollDetails?.fullName}</td>
          <td>Pay Date</td>
          <td>
            :&nbsp;&nbsp;&nbsp;
            {format(new Date(payrollDetails?.paymentDate), "dd-MM-yyyy")}
          </td>
        </tr>
        <tr>
          <td>Department</td>
          <td>:&nbsp;&nbsp;&nbsp;{payrollDetails?.departmentName}</td>
          
          <td>DOB / Age</td>
          <td>
            :&nbsp;&nbsp;&nbsp;{payrollDetails?.hpno}
          </td>
        </tr>

        <tr>
          <td>Job Title</td>
          <td>:&nbsp;&nbsp;&nbsp;{payrollDetails?.jobTitle}</td>
          <td>FIN / IC Number</td>
          <td>
            :&nbsp;&nbsp;&nbsp;
            {payrollDetails?.finNumber}
            {payrollDetails?.icno}
          </td>
        </tr>

        <tr>
          <td>Paymode</td>
          <td>:&nbsp;&nbsp;&nbsp;{payrollDetails?.paymentMode}</td>
          <td>Bank Details</td>
          <td>
            :&nbsp;&nbsp;&nbsp;{payrollDetails?.bankname}&nbsp;
            {payrollDetails?.accountNo || ""}
          </td>
        </tr>

        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>Hourly Salary</td>
          <td>
            :&nbsp;&nbsp;&nbsp;{Number(payrollDetails?.hourlySalary).toFixed(2)}
            &nbsp;
          </td>
        </tr>
      </table>

      <div className={styles["wrapper"]}>
        <div className={styles["table-container"]}>
          <div className={`${styles["table-header"]} mb-2`}>Earning (SGD)</div>

          {payrollDetails?.earningsList.map(
            (pd, _k) =>
              Number(pd?.amount) !== Number(0) && (
                <div className={styles.payrollListRow} key={_k}>
                  <span className={styles.label}>{pd?.description}</span>
                  <span className={styles.value}>
                    {Number(pd?.amount).toFixed(2)}
                  </span>
                </div>
              )
          )}
          <div className={styles["footer"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Gross Total</span>
              <span className={styles.value}>
                {Number(payrollDetails?.grossSalary).toFixed(2)}
              </span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>OT Amount</span>
              <span className={styles.value}>
                {Number(payrollDetails?.otTotal).toFixed(2)}
              </span>
            </div>
          </div>

          <div className={styles["footer-2"]}>
            {/* <div className={styles.payrollListRow}>
              <span className={styles.label}>Gross Salary</span>
              <span>{payrollDetails?.grossSalary}</span>
            </div> */}
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Employer CPF</span>
              <span>{Number(payrollDetails?.employerCpf).toFixed(2)}</span>
            </div>
            {/* <div className={styles.payrollListRow}>
              <span className={styles.label}>YTD Gross Salary</span>
              <span>695.90</span>
            </div> */}
          </div>
        </div>

        <div className={styles["table-container"]}>
          <div className={`${styles["table-header"]} mb-2`}>
            Deductions (SGD)
          </div>
          {payrollDetails?.deductionsList.map(
            (pd, _k) =>
              Number(pd?.amount) !== Number(0) && (
                <div className={styles.payrollListRow} key={_k}>
                  <span className={styles.label}>{pd?.description}</span>
                  <span className={styles.value}>
                    {Number(pd?.amount).toFixed(2)}
                  </span>
                </div>
              )
          )}

          <div className={styles["footer"]}>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Total Deduction</span>
              <span className={styles.value}>
                {Number(payrollDetails?.totalDeduction).toFixed(2)}
              </span>
            </div>
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Net Payment</span>
              <span className={styles.value}>
                {Number(payrollDetails?.netPay).toFixed(2)}
              </span>
            </div>
          </div>

          <div className={styles["footer-2"]}>
            {/* <div className={styles.payrollListRow}>
              <span className={styles.label}>Total Deductions</span>
              <span>695.90</span>
            </div> */}
            <div className={styles.payrollListRow}>
              <span className={styles.label}>Net Salary</span>
              {Number(payrollDetails?.netPay).toFixed(2)}
            </div>
            {/* <div className={styles.payrollListRow}>
              <span className={styles.label}>YTD Employee Salary</span>
              <span>695.90</span>
            </div> */}
          </div>
        </div>
      </div>

      <div className={styles.signatureSection}>
        <div className={styles.label}>
          Prepared By : {payrollDetails?.reviewedBy}
        </div>
        <div className={styles.label}>
          Approved By : {payrollDetails?.approvedBy}
        </div>
        <div className={styles.label}>
          Received By : {payrollDetails?.reviewedBy}
        </div>
        <div className={styles.label}>
          Employee Signature : _________________________
        </div>
      </div>

      <div className={styles["bottom-text"]}>
        <p className="text-center">
          This is computer generated payslip, No Signature is required.
        </p>
      </div>
    </div>
  );
};
NetcoHourlyPayslip.propTypes = {
  payrollDetails: PropTypes.array.isRequired,
  companyDetails: PropTypes.object.isRequired,
};
export default NetcoHourlyPayslip;
